import type {
  BrandFontFile,
  BrandFonts,
} from "@hightouch/lib/brand-profiles/types";

import { useBrandProfileFontsQuery } from "src/graphql";

/**
 * Font files of one profile, or of every profile in the workspace when given none.
 *
 * Reads `brandProfileFonts` rather than the raw `fonts` jsonb: the server parses each binary's
 * typographic identity (family, PostScript name, subfamily) and applies the collision rename the
 * agent's markup was written against. Export surfaces that label fonts for Figma or Photoshop
 * need both, and the persisted rows carry neither for pre-metadata uploads.
 */
export async function fetchBrandProfileFontFiles(
  brandProfileId: string | undefined,
): Promise<BrandFontFile[]> {
  const data = await useBrandProfileFontsQuery.fetcher(
    brandProfileId ? { brandProfileIds: [brandProfileId] } : {},
  )();
  return data.brandProfileFonts.flatMap(
    (entry) => (entry.fonts as BrandFonts | null)?.files ?? [],
  );
}
